export const downloadBase64String = (base64String, fileName) => {
  const linkSource = `data:application/octet-stream;base64,${base64String}`;

  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};
